import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { LoginValidationComponent } from '../../../book-create/login-validation.component/login-validation.component';
import { FooterComponent } from '../../../shared/components/footer/footer.component';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { UserPermissionService } from '../../../shared/services/apis/platform/user-permission.service';
import { ListUserPermissionResponse } from '../../../shared/services/responses/platform/user-permission.response';
import { UserPermissionStruct } from '../../../shared/services/structs/user-permission.struct';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-user-permission-list',
  standalone: true,
  templateUrl: './user-permission-list.component.html',
  styleUrls: ['./user-permission-list.component.css'],
  imports: [
    CommonModule,
    MenuComponent,
    FooterComponent,
    LoginValidationComponent,
    MatIconModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatButtonModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserPermissionListComponent implements OnInit {
  isLoading = false;
  list: UserPermissionStruct[] = [];

  constructor(
    private userPermissionService: UserPermissionService,
    private alertService: AlertService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onLoginValidated(isLogged: boolean) {
    if (!isLogged) return;
    this.fetch();
  }

  fetch(): void {
    this.isLoading = true;
    this.userPermissionService.list().subscribe({
      next: (res: ListUserPermissionResponse) => {
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription || 'Falha ao carregar a lista.', AlertType.error);
          this.isLoading = false;
          this.cdr.markForCheck();
          return;
        }
        this.list = res.listUserPermission || [];
        this.isLoading = false;
        this.cdr.markForCheck();
      },
      error: () => {
        this.alertService.show('Erro', 'Erro inesperado ao carregar a lista.', AlertType.error);
        this.isLoading = false;
        this.cdr.markForCheck();
      }
    });
  }

  newUser(): void {
    // Ajuste a rota conforme seu app
    this.router.navigateByUrl('/usuarios-admin/novo');
  }

  editUserPermissions(idUser: number): void {
    if (!idUser) return;
    // Ajuste a rota conforme seu app
    this.router.navigateByUrl(`/usuarios-admin/novo/${idUser}`);
  }

  deleteAll(idUser: number, userName: string): void {
    if (!idUser) return;

    this.isLoading = true;
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Remover permissões',
        description: `Deseja remover todas as permissões do usuário ${userName}?`,
        buttonConfirm: 'Sim, remover',
        buttonClose: 'Cancelar'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.confirm) {
        this.userPermissionService.deleteByUser(idUser).subscribe({
          next: (res) => {
            if (res.isError) {
              this.alertService.show('Erro', res.errorDescription || 'Falha ao excluir permissões.', AlertType.error);
            } else {
              this.alertService.show('Sucesso', 'Permissões removidas.', AlertType.success);
              this.fetch();
            }
          },
          error: () => {
            this.alertService.show('Erro', 'Erro inesperado ao excluir permissões.', AlertType.error);
            this.isLoading = false;
            this.cdr.markForCheck();
          }
        });
      }
      else {
        this.isLoading = false;
      }
    });
    
        this.isLoading = false;
  }

  trackByUser = (_: number, u: UserPermissionStruct) => u?.idUser ?? _;
  permTooltip(u: UserPermissionStruct): string {
    const ids = (u.listUserPermission || []).map(x => x.idPermission);
    if (!ids.length) return 'Sem permissões';
    return `IDs: ${ids.join(', ')}`;
  }
}
